const handleApiErrors = (response: any) => {
  // Response status is not 200
  if (response?.status !== 200 && response?.data) {
    const json = response.data
    if (response.status === 401) {
      throw new Error(json.result.message)
    } else if (response.status === 500) {
      throw new Error(json.result.message)
    } else if (response.status === 404) {
      throw new Error(json.result.message || 'Not Found')
    } else if (response.status === 400) {
      throw new Error(json.result.message)
    }
  }

  // Response status - 200
  return response?.data
}

export { handleApiErrors }
